<template>
    <InputDropdownCheckboxes
        translationkey="general.choose-racegroups"
        v-model="filteredRaceGroups"
        :data="raceGroups"
        :hasSelectAllCheckbox="true"
        :icon="featureIcons.GROUPS"
    />
</template>
<script setup lang="ts">
import { InputDropdownCheckboxes } from '@/components';
import { featureIcons } from '@/components/Menu/featureicons';
import { useEventCommonStore } from '@/stores';
import type { RacesGroupsCategoriesMap } from '@/utilities/RacesGroupsCategoriesMap';
import type { GroupId, RaceId } from '@/utilities/typealiases';
import { computed } from 'vue';

const props = defineProps<{
    /**
     * A {@see RacesGroupsCategoriesMap} that can provide the possible racegroup choices based on the raceID
     */
    racesGroupsCategoriesMap: RacesGroupsCategoriesMap;

    /**
     * The currently selected race (if any)
     */
    raceIDs: RaceId[] | null;
}>();
const filteredRaceGroups = defineModel<GroupId[]>({ required: true });

const raceGroups = computed(() => {
    const groupIDs = props.raceIDs?.flatMap((raceId) => props.racesGroupsCategoriesMap.GetGroupIDs(raceId)) ?? [];

    return Array.from(useEventCommonStore().GroupsAsSelectLine.values()).filter((g) => groupIDs.includes(g.value as number));
});
</script>
